<template>
  <!-- Cover -->
  <div class=" py-5 section-aquamarine cover" :style="backgroundFundo" >
    <div class="container-fluid">
      <div class="row text-center align-items-center">
        <div class="col-md-5">
          <img class="img-fluid" src="@/assets/imagens/cover_corona_texto_branco.png" alt="Fundo Cover">
          <!--<p class="display-3 font-weight-bold text-white">Está com sintomas <span class="text-danger">gripais</span>?</p>
          <p class="display-5 font-weight-bold text-dark">Se você estiver com febre alta, tosse, dor no corpo ou falta de
              ar. Ligue para o TeleCorona:</p>
          <p class="display-3 font-weight-bold text-white"><img class="img-fluid rounded-circle p-0"
                                                                src="sites/covid19/logo_telefone.png"
                                                                alt="Fundo Cover Telefone"> (45) 3055-8872</p>-->
        </div>
        <div class="col-md-7 align-items-center">
          <img class="img-fluid rounded-circle p-3" src="@/assets/imagens/cover_corona_heroi.jpg" width="75%" alt="Fundo Cover">
        </div>
        <div class="col-lg-12 text-white mt-5">
          <a href="#prevencao"><i class="d-block fa fa-angle-down pt-5 fa-3x"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bloco2Cover",
  data() {
    return {
      backgroundFundo: {
        backgroundImage: `url(${require('@/assets/imagens/fundo_lago.jpg')})`
      }
    }
  }
}
</script>

<style scoped>

</style>